import { update }  from 'state/util';

// register UI flow steps
export const UI_FLOW = {
  // we're about to begin a register, or nothing (default state)
  NONE: 0,
  // we've successfully began  a user registation
  AWAITING_VERIFICATION: 1,
  // user has been successfully registered
  COMPLETE: 2,
};

/**
 * User registration state reducer.
 * {
 *   # status describes state of registration:
 *   status: null|AWAITING_VERIFICATION|COMPLETE
 *   message: ...
 * }
 */
const initialState = {
  status: UI_FLOW.NONE,
  message: null,
};

export const registrationReducer = (state, action) => {
  if (state === undefined) {
    return initialState;
  }

  switch(action.type) {
    case "LOGOUT_REQUESTED":
      return initialState;

    case "REGISTER_PENDING":
      return update(state, {
        message: 'Beginning user registration...'
      });

    case "REGISTER_SUCCESSFUL":
      return update(state, {
        status: UI_FLOW.AWAITING_VERIFICATION,
        message: action.payload.message,
      });

    case "REGISTER_FAILED":
      return update(state, {
        message: action.payload.message
      });

    case "REGISTER_COMPLETE_PENDING":
      return update(state, {
        message: 'Finalizing user registration...'
      });

    case "REGISTER_COMPLETE_SUCCESSFUL":
      return update(state, {
        status: UI_FLOW.COMPLETE,
        message: action.payload.message,
      });

    case "REGISTER_COMPLETE_FAILED":
      return update(state, {
        message: action.payload.message
      });

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/state/registration/reducer.js